import { IonImg } from '@ionic/react';
import React from 'react';

import logo from '@/assets/images/logo/logo-with-icon.png';
import { Icon } from '@/components/memo';

import './Logo.css';

interface LogoProps {
  leftIcon?: string | null;
  onClickLeftIcon?: () => void;
  rightIcon?: string | null;
  onClickRightIcon?: () => void;
  rightContent?: React.ReactNode;
}

const Logo: React.FC<LogoProps> = ({
  leftIcon,
  onClickLeftIcon = () => {},
  rightIcon,
  onClickRightIcon = () => {},
  rightContent
}) => {
  const bloop = (e: React.MouseEvent<HTMLIonImgElement, MouseEvent>) => {
    const imageElement = e.currentTarget;
    if (imageElement.classList.contains('bloop')) {
      return;
    }
    imageElement.classList.add('bloop');
    setTimeout(() => {
      imageElement.classList.remove('bloop');
    }, 1000);
  };

  return (
    <div className="logo">
      {leftIcon && (
        <Icon
          icon={leftIcon}
          onClick={onClickLeftIcon}
          className="logo__left-icon"
        />
      )}
      <IonImg src={logo} className="logo__image" onClick={bloop} />
      {rightContent ||
        (rightIcon && (
          <Icon
            icon={rightIcon}
            onClick={onClickRightIcon}
            className="logo__right-icon"
          />
        ))}
    </div>
  );
};

export default Logo;
